import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  // ==== request counter ====
  private count = 0;

  // ==== loading state ====
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  // ==== progress state ====
  private progressSubject = new BehaviorSubject<number>(0);
  progress$ = this.progressSubject.asObservable();

  // ==== timer ====
  private interval: any;

  // =====================================
  // SHOW LOADER
  // =====================================
  show(): void {
    this.count++;

    if (this.count === 1) {
      this.loadingSubject.next(true);
      this.progressSubject.next(0);
      this.startProgress();
    }
  }

  // =====================================
  // AUTO PROGRESS
  // =====================================
  private startProgress(): void {
    clearInterval(this.interval);

    this.interval = setInterval(() => {
      const current = this.progressSubject.value;

      if (current < 90) {
        const inc = Math.random() * 10;
        this.progressSubject.next(current + inc);
      }
    }, 200);
  }

  // =====================================
  // COMPLETE
  // =====================================
  private complete(): void {
    this.progressSubject.next(100);
    clearInterval(this.interval);
  }

  // =====================================
  // HIDE LOADER
  // =====================================
  hide(): void {
    this.count--;

    if (this.count <= 0) {
      this.count = 0;

      this.complete();

      setTimeout(() => {
        this.loadingSubject.next(false);
        this.progressSubject.next(0);
      }, 250);
    }
  }
}
